import Tooltip from '@mui/material/Tooltip';
import { format, formatDistanceToNowStrict } from 'date-fns';
import { enUS } from 'date-fns/locale';

import type { JSX } from 'react';

type DateCellProps = {
  date: string | number | Date;
};

export const DateCell = ({ date }: DateCellProps): JSX.Element => {
  const parsedDate = new Date(date);

  return (
    <Tooltip title={format(parsedDate, 'PPpp', { locale: enUS })}>
      <span>{formatDistanceToNowStrict(parsedDate, { addSuffix: true })}</span>
    </Tooltip>
  );
};
